import { AppTable } from './app-table';
import { createAsyncSelectors } from '@lib/selectors';
import { FeatureBoundary } from '@ui/features';
import React from 'react';
import { SonarCard } from '@ui/general';
import { Space } from 'antd';

import { CHANGE_EVENT_PREFERENCES, COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { ChangeEvents, DisableDataSecurityButton } from './change-events';
import { coreActions, FeatureFlag } from '@sonar-software/sonar-core';
import { useAction, useAsyncState, useOnMount } from '@hooks';

const dataSecurityStatusSelectors = createAsyncSelectors((state) => state.core.dataSecurity.status.get);

export const IntegratedApps: React.FC = () => {
	const { data, isRequested } = useAsyncState(dataSecurityStatusSelectors);
	const loadDataSecurityStatus = useAction(coreActions.requestGetCoreDataSecurityStatus);

	useOnMount(() => {
		loadDataSecurityStatus();
	});

	return (
		<Space direction='vertical'>
			<FeatureBoundary feature={ FeatureFlag.DataSecurityDashboard }>
				<SonarCard
					extra={
						<DisableDataSecurityButton isEnabled={ data } />
					}
					title={ CHANGE_EVENT_PREFERENCES.SELECTED_OBJECTS }>
					<ChangeEvents
						isEnabled={ data }
						isLoading={ isRequested } />

				</SonarCard>
			</FeatureBoundary>
			<SonarCard
				noSpacingX
				title={ COPY_SPECIFIC.INTEGRATED_APPS }>
				<AppTable />
			</SonarCard>
		</Space>
	);
};
